import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const PaperclipIcon = (props: IconProps) => (
  <Icon width="20px" height="20px" viewBox="0 0 20 20" {...props}>
    <path d="M13.75 5v9.584a3.332 3.332 0 1 1-6.667 0V4.167a2.084 2.084 0 0 1 4.167 0v8.75a.836.836 0 0 1-.833.834.836.836 0 0 1-.833-.834V5.001h-1.25v7.916a2.084 2.084 0 0 0 4.166 0v-8.75a3.332 3.332 0 1 0-6.667 0v10.417a4.58 4.58 0 0 0 4.584 4.583A4.58 4.58 0 0 0 15 14.584V5.001h-1.25Z" />
  </Icon>
);
export default memo(PaperclipIcon);
